/** An app activity's beginning marker. As we are using Otel, this is Otel's Activity interface object */
export class TelemetryActivity {
    constructor(activityName, activityEventType, startTime, operationName, component, activityCorrelationId, description) {
        this.activityName = activityName;
        this.activityEventType = activityEventType;
        this.startTime = startTime;
        this.operationName = operationName;
        this.component = component;
        this.activityCorrelationId = activityCorrelationId;
        this.description = description;
        this.correlationId = activityCorrelationId;
    }
}
//# sourceMappingURL=telemetryActivity.js.map